/* ---------------------------------------------------------------------------
   cart-trust.js — Versandschutz-Schalter im Warenkorb-Drawer

   Der Versandschutz ist ein echtes Shopify-Produkt. Der Schalter legt es in
   den Warenkorb bzw. entfernt es wieder; der sichtbare Zustand kommt immer
   aus dem serverseitig gerenderten Liquid (snippets/cart-trust.liquid), nicht
   aus dem DOM. Dieses Script fuehrt nur Schreibvorgaenge aus.

   Drei Regeln:
     1. Schalter AN   -> Produkt hinzufuegen, Abwahl-Merker loeschen
     2. Schalter AUS  -> Zeile entfernen, Abwahl im localStorage merken
     3. Automatik     -> Solange der Kunde nicht aktiv abgewaehlt hat, wird der
                         Versandschutz ergaenzt, sobald echte Artikel im
                         Warenkorb liegen. Liegt kein echter Artikel mehr im
                         Warenkorb, wird er wieder entfernt.

   Der Kassenknopf wird bewusst nicht angefasst: kein preventDefault, kein
   eigener Submit-Pfad. Waehrend eines laufenden Schreibvorgangs ist nur der
   Schalter gesperrt, nicht der Drawer.
   --------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.cartTrustInit) return;
  window.cartTrustInit = true;

  var OPT_OUT_KEY = 'fm:cart-protect:opt-out';
  var busy = false;
  var failed = false;
  var syncTimer = null;

  function root() {
    return document.querySelector('[data-cart-protect]');
  }

  function optedOut() {
    try {
      return window.localStorage.getItem(OPT_OUT_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function setOptedOut(value) {
    try {
      if (value) {
        window.localStorage.setItem(OPT_OUT_KEY, '1');
      } else {
        window.localStorage.removeItem(OPT_OUT_KEY);
      }
    } catch (error) {
      /* Privater Modus: dann greift nur der Serverzustand. */
    }
  }

  function setBusy(value) {
    busy = value;
    var element = root();
    if (element) element.dataset.busy = value ? 'true' : 'false';
  }

  function post(url, payload) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(
        Object.assign({ sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }, payload)
      ),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error((data && data.description) || 'cart_write_failed');
        return data;
      });
    });
  }

  /* Aktualisiert den Drawer ohne ihn zu oeffnen. Der Kassenbereich und die
     Artikelliste werden durch die frisch gerenderten Abschnitte ersetzt,
     genau wie im Theme-eigenen CartItems.onCartUpdate(). */
  function applySections(data) {
    var sections = (data && data.sections) || {};

    if (sections['cart-drawer']) {
      var dom = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
        var target = document.querySelector(selector);
        var source = dom.querySelector(selector);
        if (target && source) target.replaceWith(source);
      });

      var checkout = document.getElementById('CartDrawer-Checkout');
      var sourceCheckout = dom.querySelector('#CartDrawer-Checkout');
      if (checkout && sourceCheckout) checkout.disabled = sourceCheckout.hasAttribute('disabled');
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var sourceBubble = new DOMParser()
        .parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (bubble && sourceBubble) bubble.innerHTML = sourceBubble.innerHTML;
    }
  }

  function addProtection(element) {
    return post(element.dataset.addUrl || '/cart/add', {
      items: [{ id: Number(element.dataset.variantId), quantity: 1 }],
    });
  }

  function removeProtection(element) {
    if (!element.dataset.lineKey) return Promise.resolve(null);
    return post(element.dataset.changeUrl || '/cart/change', { id: element.dataset.lineKey, quantity: 0 });
  }

  function run(action) {
    var element = root();
    if (!element || busy) return;

    setBusy(true);
    action(element)
      .then(function (data) {
        if (data) applySections(data);
      })
      .catch(function (error) {
        failed = true;
        /* eslint-disable-next-line no-console */
        console.error('[cart-trust]', error);
      })
      .finally(function () {
        setBusy(false);
        scheduleSync();
      });
  }

  /* --- Automatik ---------------------------------------------------------- */

  function sync() {
    var element = root();
    if (!element || busy || failed) return;
    if (element.dataset.available !== 'true') return;

    var inCart = element.dataset.inCart === 'true';
    var regularCount = Number(element.dataset.regularCount || 0);

    if (regularCount === 0 && inCart) {
      run(removeProtection);
      return;
    }

    if (regularCount > 0 && !inCart && element.dataset.defaultOn === 'true' && !optedOut()) {
      run(addProtection);
    }
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, 180);
  }

  /* --- Ereignisse --------------------------------------------------------- */

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-cart-protect-toggle]');
    if (!toggle) return;

    failed = false;
    if (toggle.checked) {
      setOptedOut(false);
      run(addProtection);
    } else {
      setOptedOut(true);
      run(removeProtection);
    }
  });

  /* Der Drawer wird von drei verschiedenen Theme-Pfaden neu gerendert. Statt
     alle drei zu kennen, wird auf jede Aenderung im Drawer reagiert. */
  function observe() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    new MutationObserver(scheduleSync).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe();
      scheduleSync();
    });
  } else {
    observe();
    scheduleSync();
  }
})();
